// 导入模块
import CuFooter from './Footer/CuFooter/index';
import CuCropper from './Cropper/CuCropper/index';
import CuTwoSelect from './TwoSelect/CuTwoSelect/index';
import CuThreeSelect from './ThreeSelect/CuThreeSelect/index';
import CuInputPopup from './InputPopup/CuInputPopup/index';
import CuNotesDeliver from './NotesDeliver/CuNotesDeliver/index';
import CuNotesDeliverResume from './NotesDeliverResume/CuNotesDeliver/index';
import CuPage from './Page/CuPage/index';
import CuRichText from "./RichText/CuRichText/index.jsx";
// 定义定数
const components = [
	
	CuFooter,
	CuCropper,
	CuTwoSelect,
	CuThreeSelect,
	CuInputPopup,
	CuNotesDeliver,
  CuNotesDeliverResume,
	CuPage,
  CuRichText
];

// 定义全局组件
import Vue from 'vue'
components.forEach(component => {
	Vue.component(component.name, component);
});

export default {
	
	CuFooter,
	CuCropper,
	CuTwoSelect,
	CuThreeSelect,
	CuInputPopup,
	CuNotesDeliver,
  CuNotesDeliverResume,
	CuPage,
  CuRichText
}


// WEBPACK FOOTER //
// ./src/packages/main.js